/** @jsxImportSource @emotion/react */
import React from 'react';
import t from '../../../theme/styles';

export function ProjectRobotCanyon() {
    return <div css={[t.bg_dark_1, t.text_tint_5, t.font_heading, t.font_bold]}>Robot Canyon</div>;
}
